
export default interface IBankPerson {
    bankPersonID?: number,
    personID?: number,

    civility?: string,
    maritalSituation?: string,
    sex?: string,

    firstName?: string,
    lastName?: string,
    personNameNIC?: string,
    birthDate?: Date,
    birthPlace?: string,
    personIndice?: string,

    defaultLanguage?: string,
    height?: number,
    weight?: number,

    adressLine1?: string,
    adressLine2?: string,
    adressLine3?: string,
    
    portable1?: string,
    portable2?: string,
    email1?: string,
    email2?: string,
    professionalCategory?: string,
    profession?: string,
}


  export const defaultBankPerson: IBankPerson = {
    bankPersonID: 0,
    personID: 0,

    civility: '',
    maritalSituation: '',
    sex: '',

    firstName: '',
    lastName: '',
    personNameNIC: '',
    birthDate: new Date(),
    birthPlace: '',
    personIndice: '',

    portable1: '',
    portable2: '',
    email1: '',
    email2: '',
    professionalCategory: '',
    profession: '',
  }

  export interface IBankPersonSearch {
    firstName: string,
    lastName: string,
    personNameNIC: string,
    phoneNumber: string,
    birthYear: number,
    birthMonth: number
  }